/* Menu Hover */

var timer

$('.navmenu-depth-1 > .navmenu-item')
  .mouseover(function() {
    //clearTimeout(timer)
    $(this).addClass('hover');
  $(this).siblings().removeClass('hover');
  })
  .mouseleave(function() {
    that = this
    timer = setTimeout(function() {
      $(that).removeClass('hover');
    }, 500);
  });
 
/* Product page Quantity */
$('.qtybox .btnqty').on('click', function(){
  var qty = parseInt($(this).parent('.qtybox').find('.quantity-input').val());
  if($(this).hasClass('qtyplus')) {
    qty++;
  }else {
    if(qty > 1) {
      qty--;
    }
  }
  qty = (isNaN(qty))?1:qty;
  $(this).parent('.qtybox').find('.quantity-input').val(qty);
}); 

$(document).ready(function(){
  var windowWidth = $(window).width();
  if(windowWidth <= 720) //for iPad & smaller devices
    $(".footer-link-list h4").click(function(){
    $(this).next('.footer-link-list ul').slideToggle();
    $(this).toggleClass('active');
  });
});

 

/* Product page ingredient accor */
$(document).ready(function(){
  $(".product-ingredient h4").click(function(){
    $(this).next('p').slideToggle();
    $(this).toggleClass('active');
  });
});
/* Product page fact link */
//$(document).ready(function(){
//  $(".product-facts h4").click(function(){
  //  $('.facts-popup').fadeIn(); 
   // $('body').addClass('no-scroll');
  //});
  //$(".product-facts .close").click(function(){
//    $('.facts-popup').fadeOut();     
//    $('body').removeClass('no-scroll');
//  });
//});
/* FAQ */
$(document).ready(function(){
  $(".faq-block h4").click(function(){
    $(this).next('.block').slideToggle();
    $(this).toggleClass('active');
  });
});
/*Smooth href */
// Select all links with hashes
$(document).ready(function() {
  $('.career-banner a[href^="#"], .adventure-sticky-header li a[href^="#"], .backTop[href^="#"]').click(function() {
      var target = $(this.hash);
      if (target.length == 0) target = $('a[name="' + this.hash.substr(1) + '"]');
      if (target.length == 0) target = $('html');
      $('html, body').animate({ scrollTop: target.offset().top-150 }, 500);
      return false;
  });
});

// Sticky Header for Adventure page
$(window).scroll(function(){
  if ($(window).scrollTop() >= 300) {
    $('.adventure-sticky-header').addClass('fixed-header');
	$('.backTop').addClass('scrolTop');
  }
  else {
    $('.adventure-sticky-header').removeClass('fixed-header');
	$('.backTop').removeClass('scrolTop');
    }
});


// Owl Slider for home
function owlInitialize() {
if ($(window).width() > 721) {
    $('.collection-slider').addClass("owl-carousel");
    $('.collection-slider.owl-carousel').owlCarousel({
        center: true,
    items: 2,    
    loop: true,
    margin: 10,
    autoWidth: false,       
        responsive: {
      0: {
        items:1,
        center: false,
        autoWidth:true,
         loop: true,
    margin: 10,
      },
      720: {
        items:3,
        center: false,
        autoWidth:false,
        margin: 20,
      }
    }
    });
}else{
    $('.collection-slider.owl-carousel').owlCarousel('destroy');
    $('.collection-slider').removeClass("owl-carousel");
}
}
$(document).ready(function(e) {
owlInitialize();
});
$(window).resize(function() {
owlInitialize();
});

// jQuery(document).ready(function($) {
 // $('.collection-slider').owlCarousel({
 //   center: true,
 //   items: 2,    
 //   loop: true,
  //  margin: 10,
  //  autoWidth: false,
  //  responsive: {
   //   0: {
    //    items:1,
     //   center: false,
    //    autoWidth:true,
    //     loop: true,
   // margin: 10,
   //   },
    //  720: {
    //    items:3,
     //   center: false,
      //  autoWidth:false,
    //    margin: 20,
    //  }
   // }
 // });

// }); 


//Homepage Banner Image change on resize - Start                   
function checkResolution() {
  if ($("img.swap").length) {
    var carouselImage = $("img.swap").attr("src");
    carouselImage = carouselImage.substr(carouselImage.lastIndexOf("/"));
    var imageName = carouselImage.split("-")[0].replace("/", "");
    //console.log("imageName:", imageName);
    var imageExtension = carouselImage.split(".")[1];
    if (imageExtension.indexOf("?") !== -1) { imageExtension = "." + imageExtension.split("?")[0]; }
    else { imageExtension = "." + imageExtension; }
    //console.log("imageExtension:", imageExtension);

    // For Desktop
    if ($(window).innerWidth() > 767) {
      $("img.swap").each(function (index) {
        $(this).attr("src", "//cdn.shopify.com/s/files/1/0268/0671/4568/files/" + imageName + "-desktop" + imageExtension)
      });
    }
    // For Mobile
    else {
      $("img.swap").each(function (index) {
        $(this).attr("src", "//cdn.shopify.com/s/files/1/0268/0671/4568/files/" + imageName + "-mobile" + imageExtension)
      });
    }
  }
}

$(window).resize(function () { checkResolution(); });
checkResolution();
//Homepage Banner Image change on resize - End

$('body').on('click', '.product-list-item input.add-to-cart', function(e) {
e.preventDefault();
var curr_elem = $(this);
$(this).val('Please wait...');
         $(this).attr('disabled',true);
         var toadd=[];
         var toItem=[];
 var qty = 1;
 
 var mainProduct = $(this).closest('form.add-cart-btn').find('input[name="id"]').val();
         toadd.push({
           variant_id: mainProduct,        
           quantity_id: qty

         });
         toItem.push({
           variant_id: mainProduct,        
           quantity_id: qty
         });
 
 function moveAlong(){
           if (toadd.length) {
             var request = toadd.shift();
             var tempId= request.variant_id;
             var tempQty = request.quantity_id;
             var params = {
               type: 'POST',
               url: '/cart/add.js',
               data: 'quantity='+tempQty+'&id='+tempId,
               dataType: 'json',
               success: function(line_item) {
                 var cartdata = [];
       $.ajax({
         type: 'GET',
         url: '/cart.js',
         async: false,
         cache: false,
         dataType: 'json',
         success: function (json) {
           cartdata = json;
         }
       });
       $('a.header-tools-cart span.cart-item-count').html(cartdata.item_count);
  //ajax cart update on add-to-cart  
   onSkeleton();
  toggleDrawer();
   //console.log(line_item);
 $(curr_elem).closest('.product-list-item').find('.cartBtnBlock').html('<span>Product added to cart</span>');
 $(curr_elem).closest('.product-list-item').find('.cartBtnBlock').css({'color':'green'});
 $(curr_elem).closest('.product-list-item').find('.cartBtnBlock').fadeToggle(200);
 setTimeout(function(){
 $(curr_elem).val('add to cart');
 $(curr_elem).attr('disabled',false);
 }, 500);
 setTimeout(function(){
 $(curr_elem).closest('.product-list-item').find('.cartBtnBlock').html('');
 $(curr_elem).closest('.product-list-item').find('.cartBtnBlock').fadeToggle(200);
 }, 1500);
               },
               error: function(a,b) {
                 if($(curr_elem).closest('.product-list-item').find('.cartBtnBlock').length) {
                   $(curr_elem).closest('.product-list-item').find('.cartBtnBlock').html('<span>'+ a.responseJSON.description + '</span>');
$(curr_elem).closest('.product-list-item').find('.cartBtnBlock').css({'color':'red'});
   $(curr_elem).closest('.product-list-item').find('.cartBtnBlock').fadeToggle(200);
                 }
                 setTimeout(function(){
 $(curr_elem).val('add to cart');
 $(curr_elem).attr('disabled',false);
 }, 500);
 setTimeout(function(){
 $(curr_elem).closest('.product-list-item').find('.cartBtnBlock').html('');
 $(curr_elem).closest('.product-list-item').find('.cartBtnBlock').fadeToggle(200);
 }, 1500);
               }
             };

             $.ajax(params);
           }
         };
         moveAlong();
});


//if ($(".adventure-sticky-header  li a").length) { 
  // $('.adventure-sticky-header li a').click(function(){
  //$(this).closest('li').addClass('active').siblings().removeClass('active');
//})
   
//}


 $(document).ready(function() {
  $('.owl-pro').owlCarousel({
    loop: true,
    margin: 10,
    nav: true,
    responsiveClass: true,
    responsive: {
      0: {
        items: 3,
        nav: true
      },
      600: {
        items: 4
         
      },
      1000: {
        items: 5,
        
        loop: false

      }
    }
  })
})
 /****************************Home And Product page Accordion JS Start *****************/
 

 var acc = document.getElementsByClassName("accordion");

var i;

for (i = 0; i < acc.length; i++) {
  acc[i].addEventListener("click", function() {
    this.classList.toggle("active");
    var panel = this.nextElementSibling;
    if (panel.style.maxHeight) {
      panel.style.maxHeight = null;
    } else {
      panel.style.maxHeight = panel.scrollHeight + "px";
    } 
  });
}
/**************************** Home And Product page Accordion JS End *****************/

/***************** Product Page Title movement With Js *********************/
let productGallery = document.querySelector('.template-product .product-gallery.clearfix');

let productTitle = document.querySelector('.template-product .product-details h1.page-title');
if(window.innerWidth < 767 ){
  
productTitle.appendChild(productGallery);
}
/***************** Product Page Title movement With Js *********************/


/********************** Blacklist Spam Search Code Start **************************/
if (window.location.search !== '' && window.location.search !== '?') {
    const params = new URLSearchParams(window.location.search);
    let queries = {};
    for(var value of params.keys()) {
         queries[value] = params.get(value);
    }
    let blacklist_words = [
        '泥巴影院',
        '中国电话号码查人',
        '电话查人',
		'ee1899·com',
		'乱伦',
		'水原美園',
		'鐘興樺 李銘展',
		'2022av推荐',
		'坂口杏里av',
		'花梨 av',
		'泥巴yingyuan',
		'аугустин',
		'сщщлшу',
		'水原 美園',
		'チョコレート ミッシェル',
		'扫',
        'بسكويت سافوري',
        '谷歌留痕'
    ];
    for (const [key, value] of Object.entries(queries)) {
        if (
            (/[^\x00-\x7F]+/.test( value ) && key === 'q') ||
            (/[^\x00-\x7F]+/.test( value ) && key === 'search_query') ||
            (/[^\x00-\x7F]+/.test( value ) && key === 's') ||
            (blacklist_words.length && blacklist_words.includes(value))
        ) {
            window.location.href = window.location.href.split('?')[0]
        }
    }
}

/********************** Blacklist Spam Search Code End **************************/